import InsuranceNavbar from '../components/InsuranceNavbar';
import InsuranceHero from '../sections/InsuranceHero';
import InsuranceChallenge from '../sections/InsuranceChallenge';
import InsuranceSolution from '../sections/InsuranceSolution';
import InsurancePartnershipJourney from '../sections/InsurancePartnershipJourney';
import InsurancePackages from '../sections/InsurancePackages';
import InsuranceFeatures from '../sections/InsuranceFeatures';
import InsuranceResults from '../sections/InsuranceResults';
import InsuranceCTA from '../sections/InsuranceCTA';
import InsuranceFooter from '../components/InsuranceFooter';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <InsuranceNavbar />
      <InsuranceHero />
      <InsuranceChallenge />
      <InsuranceSolution />
      <InsurancePartnershipJourney />
      <InsurancePackages />
      <InsuranceFeatures />
      <InsuranceResults />
      <InsuranceCTA />
      <InsuranceFooter />
    </div>
  );
};

export default Home;
